import { createNode } from '@glueapp/graph-types';

export const SelectItemFromList = createNode({
    id: 'Select Item from List',
    name: 'Select Item from List',
    description: 'Select an item from a list',
    aiDescription:
        'Retrieves an item at a specific index from a list. Connect "List" and set "Index" (number, 0-based). Output: "Selected Item" (optional, null if index is out of bounds).',
    category: 'List',
    color: '#778ed5',
    integration: undefined,
    inPorts: {
        List: {
            kind: 'array',
            subType: {
                kind: 'generic',
                identifier: 'T',
            },
        },
        Index: {
            kind: 'number',
        },
    },
    outPorts: {
        'Selected Item': {
            kind: 'generic',
            identifier: 'T',
        },
    },
    optionalOutPorts: ['Selected Item'],
    execute: function (input) {
        const inputArray = input.inPorts.List;
        const index = input.inPorts.Index;
        const item = inputArray[index];
        if (item !== undefined) {
            return { output: { 'Selected Item': item } };
        } else {
            return { output: { 'Selected Item': null } };
        }
    },
});
